import { type Dispatch, type SetStateAction } from 'react';
import { useForm, Controller } from 'react-hook-form';

type FormData = {
    code: number;
};

interface UseConfirmFormParams {
    submitHandler: (code: number) => Promise<void>;
    setCode: Dispatch<SetStateAction<string>>;
}

export const useConfirmForm = ({ submitHandler, setCode }: UseConfirmFormParams) => {
    const { register, handleSubmit, control, reset } = useForm<FormData>();

    const onSubmitForm = handleSubmit(async (data: FormData) => {
        await submitHandler(data.code);
        reset();
        setCode('');
    });

    return {
        control,
        Controller,
        register,
        onSubmitForm,
    };
};
